import React from 'react'
import styled from 'styled-components'
import {components} from 'react-select'

import config from 'config'

const getBackgroundImage = props => {
  if (props.isFocused && props.theme.select.icon.focusImage) {
    return props.theme.select.icon.focusImage
  }

  return props.theme.select.icon.image
}

const InputDropdownIndicatorView = styled.div`
  background-image: url(${config.url}/assets/${getBackgroundImage});
  transform: ${props => props.isFocused && 'scaleY(-1)'};
  width: ${props => props.theme.select.icon.width};
  height: ${props => props.theme.select.icon.height};
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`

const InputDropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <InputDropdownIndicatorView isFocused={props.selectProps.menuIsOpen} />
  </components.DropdownIndicator>
)

export default InputDropdownIndicator
